import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCirclePlus, faFileExport, faFileImport, faFolderTree, faList, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { FileUploadModule, FileUploader } from 'ng2-file-upload';
import { DefaultHttpService } from 'src/app/services/default-http.service';
import { MemoryService } from 'src/app/services/memory.service';

import { MatExpansionModule } from '@angular/material/expansion';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-list-header',
    templateUrl: './list-header.component.html',
    styleUrls: ['./list-header.component.scss'],
    imports: [MatExpansionModule, MatButtonModule, FaIconComponent, FileUploadModule],
})
export class ListHeaderComponent extends DefaultHttpService implements OnInit {
    /**
     * Liste des icônes utilisés dans le template
     */
    public faAdd = faCirclePlus;
    public faFileExport = faFileExport;
    public faFileImport = faFileImport;
    public faQuestion = faQuestion;
    public faFolderTree = faFolderTree;
    public faList = faList;

    @Input()
    titleText: string;

    @Input()
    createIconText: string = 'Mode création';

    @Input()
    createRight: boolean = false;

    @Input()
    importDatasourceName: string = undefined;

    @Input()
    buttonDisplayListVisible: boolean = false;

    @Input()
    buttonDisplayTreeVisible: boolean = false;

    @Output()
    created: EventEmitter<boolean> = new EventEmitter();

    @Output()
    exported: EventEmitter<boolean> = new EventEmitter();

    @Output()
    imported: EventEmitter<boolean> = new EventEmitter();

    @Output()
    helped: EventEmitter<boolean> = new EventEmitter();

    @Output()
    listDisplayed: EventEmitter<boolean> = new EventEmitter();

    @Output()
    treeDisplayed: EventEmitter<boolean> = new EventEmitter();

    // Accès au enfant de type fileToUpload
    @ViewChild('fileToUpload', { static: false }) fileToUploadVariable: ElementRef;

    // Composant FileUploaderCustom
    public uploader: FileUploader = null;

    constructor(
        public override memoryService: MemoryService,
        private spinner: NgxSpinnerService
    ) {
        super(memoryService);
    }

    ngOnInit(): void {
        let url = `${this.baseUrl}/api/organizations/${this.organizationId}/${this.importDatasourceName}/import`;

        if (
            this.importDatasourceName == 'attributedefinitions' ||
            this.importDatasourceName == 'boxgroups' ||
            this.importDatasourceName == 'boxes' ||
            this.importDatasourceName == 'listLayoutsBoxes' ||
            this.importDatasourceName == 'listLayoutsWorkflows' ||
            this.importDatasourceName == 'channels' ||
            this.importDatasourceName == 'processdefinitions'
        ) {
            url = `${this.baseUrl}/api/organizations/${this.organizationId}/views/${this.viewId}/${this.importDatasourceName}/import`;
        }

        this.uploader = new FileUploader({
            url: url,
            authTokenHeader: 'Authorization',
            authToken: `Bearer ${this.connectedUser.token.accessToken}`,
            allowedFileType: ['xls'],
            removeAfterUpload: true,
            queueLimit: 1,
        });

        this.uploader.onAfterAddingFile = (fileItem) => {
            fileItem.withCredentials = false;
        };

        this.uploader.onCompleteAll = () => {
            this.imported.emit(true);
            this.spinner.hide('main-spinner');
        };

        this.uploader.onBeforeUploadItem = () => {
            this.spinner.show('main-spinner');
        };

        this.uploader.onErrorItem = () => {
            this.spinner.hide('main-spinner');
        };
    }

    public onFileSelected() {
        this.uploader.uploadAll();

        // Workaround pour pouvoir sélectionner à plusieurs reprises un fichier .xlsx avec le même nom
        // https://github.com/valor-software/ng2-file-upload/issues/871
        this.fileToUploadVariable.nativeElement.value = '';
    }

    public onCreation(): void {
        this.created.emit(true);
    }

    public onExport(): void {
        this.exported.emit(true);
    }

    public onHelp(): void {
        this.helped.emit(true);
    }

    public onDisplayList(): void {
        this.listDisplayed.emit(true);
    }

    public onDisplayTree(): void {
        this.treeDisplayed.emit(true);
    }
}
